import * as React from 'react';
import {Helmet} from 'react-helmet';
// @ts-expect-error
import type {Location} from 'react-router-dom';

// @ts-expect-error
import capitalize from 'underscore.string/capitalize';

import {Routing} from 'nutshell-core/routing';
import type {CoreEntityType} from 'nutshell-core/types';
import {getMultipleEntityType} from 'nutshell-core/utils/get-multiple-entity-type';

import {headTitle} from 'shells/document/head-title';
import type {NutshellTour} from 'shells/tours/types';
import {useFilterUrlWatcher} from 'shells/tours/use-filter-url-watcher';
import {useNutshellTour} from 'shells/tours/use-nutshell-tour';

import {PageWrapper} from '../layout/page-wrapper';

import EntityList from './entity-list';
import {EntityListSidebarWrapper} from './entity-list-sidebar';

type Props = {
    entity: any;
    entityType: CoreEntityType;
    notifications: any[];
    isInitialized: boolean;
    tour?: NutshellTour;
    location: Location;
};

function getPageBodyId(entityType: CoreEntityType) {
    switch (entityType) {
        case 'accounts':
            return 'entity-list-companies';
        case 'contacts':
            return 'entity-list-people';
        case 'leads':
        default:
            return 'entity-list-leads';
    }
}

export function EntityListWrapper(props: Props) {
    const {entity, entityType, isInitialized, tour, location, ...restProps} = props;

    const {startTour} = useNutshellTour();
    useFilterUrlWatcher(location.search, 'closedTime', '+w4');

    const pageBody = document.querySelector('body');
    const pageBodyId = getPageBodyId(entityType);
    if (pageBody && pageBody.id !== pageBodyId) {
        pageBody.id = pageBodyId;
        pageBody.className = `page ${entityType}`;
    }

    React.useEffect(() => {
        let timeout = null;
        if (tour) {
            timeout = setTimeout(() => {
                startTour(tour);
            }, 2000);
        }

        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const searchParams = Routing.deparam(location.search);

    return (
        <PageWrapper
            sidebar={
                <EntityListSidebarWrapper
                    entityType={entityType}
                    searchParams={searchParams}
                    entities={entity.list}
                />
            }
        >
            <Helmet>
                <title>{headTitle(capitalize(getMultipleEntityType(entityType)))}</title>
            </Helmet>
            {isInitialized && (
                <EntityList
                    {...restProps}
                    entity={entity}
                    entityType={entityType}
                    tour={location.state && location.state.tour}
                />
            )}
        </PageWrapper>
    );
}
